import type { Icd10RafWeight } from '@seen/request-types/icd10RafWeights'

export interface Icd10RafWeightColumns {
  v22: string
  v28: string
}

function hasNonZeroWeight(n: number | null): boolean {
  return n != null && n !== 0
}

export function formatIcd10RafWeight(
  weights: readonly Icd10RafWeight[]
): Icd10RafWeightColumns | null {
  if (
    weights.length === 0 ||
    !weights.some((w) => hasNonZeroWeight(w.v22) || hasNonZeroWeight(w.v28))
  ) {
    return null
  }
  const fmt = (n: number | null) => (n == null ? '—' : n.toFixed(3))
  return {
    v22: weights.map((w) => fmt(w.v22)).join(', '),
    v28: weights.map((w) => fmt(w.v28)).join(', '),
  }
}
